import React from 'react';
import { FacebookIcon, InstagramIcon, YoutubeIcon } from 'lucide-react';
import { Button, Countdown, TrustBar } from './Shared';
export function CtaAndFooter() {
  return <>
      <section className="bg-white px-4 py-20 text-center" data-id="element-12" data-mp="32o4bucrusc7l">
        <div className="mx-auto max-w-3xl" data-id="element-13" data-mp="32pp7k5pwm171">
          <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-brand-orange" data-id="element-14" data-mp="36p6aardy4k8i">
            Los dos caminos
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-15" data-mp="3ufju5umdncs0">
            Hay dos versiones del lunes que viene.
          </h2>
          <div className="mt-12 grid gap-7 text-left md:grid-cols-2" data-id="element-16" data-mp="3levgj10wbefn">
            <article className="rounded-3xl border border-rose-100 bg-rose-50 p-7" data-id="element-17" data-mp="3lgonkhff80o6">
              <h3 className="text-xl font-bold text-rose-700" data-id="element-18" data-mp="3qfji2gmr3do4">El primero:</h3>
              <p className="mt-4 font-medium leading-relaxed text-brand-text" data-id="element-19" data-mp="29xlymixf0ugg">
                El próximo domingo a la noche vas a estar otra vez frente a la
                heladera. Sin saber qué mandar. Agarrando lo mismo de siempre. Y
                el lunes a las 7, con los chicos apurados, va a aparecer de
                nuevo la misma pregunta. Cuando la lonchera vuelva llena, vas a
                volver a hacerte esa pregunta que duele y no se dice en voz
                alta.
              </p>
            </article>
            <article className="rounded-3xl border border-brand-sky bg-brand-lightBlue p-7" data-id="element-20" data-mp="3qazrl73v3xwq">
              <h3 className="text-xl font-bold text-brand-blue" data-id="element-21" data-mp="80xmugrj9fnb">El segundo:</h3>
              <p className="mt-4 font-medium leading-relaxed text-brand-text" data-id="element-22" data-mp="33e3x3jw4ep1">
                Hoy descargás Meriendas que Acompañan. Esta tarde organizás el
                mes entero. El próximo domingo tomás mate con tu familia. Y el
                lunes, cuando aparezca la pregunta de siempre, ya va a estar
                respondida. Tu hijo abre la lonchera, encuentra algo diferente y
                vuelve a casa con la lonchera vacía.
              </p>
            </article>
          </div>
          <p className="mt-10 text-xl font-bold text-brand-deep" data-id="element-23" data-mp="twxv9kvlbuel">
            Esa imagen vale $390 pesos.
          </p>
          <p className="mt-3 text-lg text-brand-text" data-id="element-24" data-mp="yrv0egpr1jm7">
            El sistema ya existe. Las +300 familias uruguayas que ya lo usan ya
            tomaron la decisión.
          </p>
          <p className="mt-2 font-display text-2xl font-bold text-brand-orange" data-id="element-25" data-mp="18lbvdo1mh4rg">
            Solo falta la tuya.
          </p>
        </div>
      </section>
      <section className="bg-brand-deep px-4 py-16 text-center text-white" data-id="element-26" data-mp="1hjw8m9oeym8a">
        <div className="mx-auto max-w-3xl" data-id="element-27" data-mp="1mk1rp1gmb0er">
          <h2 className="font-display text-3xl font-bold md:text-4xl" data-id="element-28" data-mp="1ml3f85etlfdd">
            🟠 QUIERO MI MEGAPACK AHORA — $390 UYU
          </h2>
          <div className="mt-8 rounded-2xl border border-white/15 bg-white/10 p-6" data-id="element-29" data-mp="1rgipyohj6v5k">
            <Countdown data-id="element-30" data-mp="3od83n6x41ujc" />
            <p className="mt-4 font-medium text-brand-sky" data-id="element-31" data-mp="3ta8cfplchbe5">
              Después vuelve a su precio real de $590 UYU y no vuelve esta
              oferta.
            </p>
          </div>
          <div className="mx-auto mt-8 max-w-md" data-id="element-32" data-mp="2agyg1b5rp7qv">
            <Button className="py-5" data-id="element-33" data-mp="25nc97zmaby2z">
              🌟 QUIERO MI MERIENDAS QUE ACOMPAÑAN AHORA
            </Button>
            <div className="mt-6" data-id="element-34" data-mp="21nbjvjxne2h5">
              <TrustBar tone="dark" data-id="element-35" data-mp="1wnp8lg1dqwaz" />
            </div>
          </div>
          <p className="mt-8 font-bold text-brand-orange" data-id="element-36" data-mp="1wpjvgzw7oyhp">
            +300 familias uruguayas ya confían
          </p>
        </div>
      </section>
      <footer className="border-t border-white/10 bg-[#0c0a09] px-4 py-16 text-center text-gray-400" data-id="element-37" data-mp="2pbuu4509cpbv">
        <div className="mx-auto max-w-4xl" data-id="element-38" data-mp="2kcrxn8ycfrfi">
          <div className="mx-auto mb-12 max-w-xl" data-id="element-39" data-mp="2kbgk4hf3j5b7">
            <p className="text-lg font-medium leading-relaxed text-gray-300" data-id="element-40" data-mp="2feq6e0qrklsy">
              Esa pregunta silenciosa de si sos buena madre no debería depender
              de una merienda.
              <br data-id="element-41" data-mp="13zb72qb31huo" />
              <br data-id="element-42" data-mp="13ys024mz0dvf" />
              Tu hijo no debería recordar estas mañanas como el momento en que
              la lonchera volvía llena.
              <br data-id="element-43" data-mp="2rug5jkpelqqv" />
              <br data-id="element-44" data-mp="2rtwkhv4gim8m" />Y vos no deberías llegar al trabajo con esa imagen en la
              cabeza todos los días.
            </p>
            <p className="mt-7 text-xl font-bold text-white" data-id="element-45" data-mp="2ivkw7zr2c0jc">
              Meriendas que Acompañan no cambia lo que sos.
              <br data-id="element-46" data-mp="2nuxk8nto7dni" />
              <span className="text-brand-orange" data-id="element-47" data-mp="2nue1j4w74l8f">
                Cambia lo que tu hijo encuentra cuando abre la mochila.
              </span>
            </p>
            <p className="mt-7 text-lg font-medium text-brand-sky" data-id="element-48" data-mp="3fllk7wjlyczl">
              La semana resuelta.
              <br data-id="element-49" data-mp="31mc1oq7xj6sg" />
              La pregunta silenciada.
              <br data-id="element-50" data-mp="31nwx0i22itrd" />
              La lonchera que vuelve vacía.
              <br data-id="element-51" data-mp="36jcdlhrgn3rh" />
              La decisión es tuya.
            </p>
          </div>
          <p className="text-2xl font-bold text-white" data-id="element-52" data-mp="1q5cbq192141l">🐦‍🔥 Tu Fénix Digital</p>
          <p className="mt-2 font-bold uppercase tracking-[0.15em] text-brand-orange" data-id="element-53" data-mp="1v603wq90rqxe">
            MERIENDAS QUE ACOMPAÑAN · Edición 2026
          </p>
          <a href="https://www.tufenixdigital.store" className="mt-7 inline-block hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-sky" data-id="element-54" data-mp="1no281ojrgecn">
            www.tufenixdigital.store
          </a>
          <div className="mt-8 flex justify-center gap-6" data-id="element-55" data-mp="1rom6cvg2lo0d">
            <a href="https://www.facebook.com/people/Tu-Fenix-Digital/61590759474336/" target="_blank" rel="noopener noreferrer" aria-label="Seguir a Tu Fénix Digital en Facebook" className="hover:text-white" data-id="element-56" data-mp="13xykf69bkxut">
              <FacebookIcon className="h-6 w-6" data-id="element-57" data-mp="18x1p2ple1229" />
            </a>
            <a href="https://www.instagram.com/tufenixdigital_oficial/" target="_blank" rel="noopener noreferrer" aria-label="Seguir a Tu Fénix Digital en Instagram" className="hover:text-white" data-id="element-58" data-mp="18viad3fdqz2l">
              <InstagramIcon className="h-6 w-6" data-id="element-59" data-mp="2g9ltrnokyids" />
            </a>
            <a href="https://www.youtube.com/@TuFenixDigital" target="_blank" rel="noopener noreferrer" aria-label="Visitar Tu Fénix Digital en YouTube" className="hover:text-white" data-id="element-60" data-mp="2l9gpq5n7py5p">
              <YoutubeIcon className="h-6 w-6" data-id="element-61" data-mp="2v1md122irrek" />
            </a>
          </div>
          <p className="mt-8 text-sm" data-id="element-62" data-mp="1xdc9ujqzyxlv">
            © 2026 Tu Fénix Digital — Todos los derechos reservados
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-xs leading-relaxed text-gray-500" data-id="element-63" data-mp="22cyomxmh4lws">
            Este producto ofrece ideas generales de organización de meriendas
            escolares. No reemplaza la orientación de un profesional de salud o
            nutrición.
          </p>
        </div>
      </footer>
    </>;
}